import API from "../../api";

const SET_STREET = "SET_STREET";
const SET_STREET_NUMBER = "SET_STREET_NUMBER";
const SET_COMPLEMENT = "SET_COMPLEMENT";
const SET_REFERENCE = "SET_REFERENCE";
const SET_ZIP_CODE = "SET_ZIP_CODE";
const SET_NAME = "SET_NAME";
const SET_LONLAT = "SET_LONLAT";
const SET_ADDRESSABLE = "SET_ADDRESSABLE";
const SET_CITY = "SET_CITY";
const SET_DISTRICT = "SET_DISTRICT";
const SET_ADDRESS_COMPONENTS = "SET_ADDRESS_COMPONENTS";
const SET_LOCATION = "SET_LOCATION";
const RESET_STATE = "RESET_STATE";

const getDefaultState = () => {
  return {
    street: null,
    streetNumber: null,
    complement: null,
    reference: null,
    zipCode: null,
    name: null,
    lonlat: null,
    addressable: null,
    city: null,
    district: null,
    addressComponents: null,
    location: null
  };
};
function normalize(string) {
  return string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    setStreet({ commit }, payload) {
      commit("SET_STREET", payload);
    },
    setStreetNumber({ commit }, payload) {
      commit("SET_STREET_NUMBER", payload);
    },
    setComplement({ commit }, payload) {
      commit("SET_COMPLEMENT", payload);
    },
    setReference({ commit }, payload) {
      commit("SET_REFERENCE", payload);
    },
    setZipCode({ commit }, payload) {
      if (payload) payload = payload.replace(/[^0-9]/g, "");
      commit("SET_ZIP_CODE", payload);
    },
    setName({ commit }, payload) {
      commit("SET_NAME", payload);
    },
    setLocation({ commit }, location) {
      commit("SET_LOCATION", location);
      commit("SET_LONLAT", `POINT(${location.lng()} ${location.lat()})`);
    },
    setAddressable({ commit }, payload) {
      commit("SET_ADDRESSABLE", payload);
    },
    setCity({ commit }, payload) {
      commit("SET_CITY", payload);
    },
    setDistrict({ commit }, payload) {
      commit("SET_DISTRICT", payload);
    },
    async setAddressComponents({ commit, dispatch }, payload) {
      try {
        await commit("SET_ADDRESS_COMPONENTS", payload);
        await dispatch("setPlace");
      } catch (e) {
        throw e;
      }
    },
    async setPlace({ dispatch, rootState }) {
      try {
        let street = await dispatch("getComponent", "route");
        let streetNumber = await dispatch("getComponent", "street_number");
        let district = await dispatch("getComponent", "sublocality_level_1");
        let city =
          (await dispatch("getComponent", "administrative_area_level_2")) ||
          (await dispatch("getComponent", "locality"));
        let zipCode = await dispatch("getComponent", "postal_code");

        city = await API.Cities.searchByName(city);

        dispatch("setCity", city);
        dispatch("setZipCode", zipCode);

        if (district) {
          try {
            let districts = await API.Districts.searchByCityAndName({
              city: city,
              district_name: district
            });
            const userDistrict = districts.find(
              el => normalize(el.display_name) === normalize(district)
            );

            dispatch("setDistrict", userDistrict);
          } catch (_) {
            // API.Freshdesk.districtSearchTicket({
            //   email: rootState.user.user.email,
            //   city: city.display_name,
            //   district
            // });

            dispatch("setDistrict", null);
          }
        }
      } catch (e) {
        throw e;
      }
    },

    getComponent({ state }, type) {
      try {
        var res = null;

        state.addressComponents.forEach(component => {
          component.types.forEach(el => {
            if (el === type) res = component.long_name;
          });
        });

        return res;
      } catch (e) {
        throw "Ocorreu um erro ao encontrar os dados nos componentes do endereço!";
      }
    },

    async searchDistrict({ state }, textSearch) {
      try {
        return await API.Districts.searchByCityAndName({
          city: state.city,
          district_name: textSearch
        });
      } catch (e) {
        throw e;
      }
    },

    async create({ state, commit, dispatch }, queryParams) {
      try {
        let data = {
          attributes: {
            street: state.street,
            street_number: state.streetNumber,
            zip_code: state.zipCode,
            complement: state.complement,
            reference: state.reference,
            name: state.name,
            lonlat: state.lonlat
          },
          addressable: state.addressable,
          districtID: state.district.id
        };

        let res = await API.Addresses.create(data);
        commit("RESET_STATE");
        await dispatch("user/setClosedCities", null, {
          root: true
        });

        await dispatch("addresses/getAddresses", null, { root: true });
        await dispatch(
          "orderScheduler/setAddress",
          { addressId: res.id, queryParams: queryParams },
          { root: true }
        );
        return res;
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {
    [SET_STREET](state, payload) {
      state.street = payload;
    },
    [SET_STREET_NUMBER](state, payload) {
      state.streetNumber = payload;
    },
    [SET_COMPLEMENT](state, payload) {
      state.complement = payload;
    },
    [SET_REFERENCE](state, payload) {
      state.reference = payload;
    },
    [SET_ZIP_CODE](state, payload) {
      state.zipCode = payload;
    },
    [SET_NAME](state, payload) {
      state.name = payload;
    },
    [SET_LONLAT](state, payload) {
      state.lonlat = payload;
    },
    [SET_ADDRESSABLE](state, payload) {
      state.addressable = payload;
    },
    [SET_CITY](state, payload) {
      state.city = payload;
    },
    [SET_DISTRICT](state, payload) {
      state.district = payload;
    },
    [SET_ADDRESS_COMPONENTS](state, payload) {
      state.addressComponents = payload;
    },
    [SET_LOCATION](state, payload) {
      state.location = payload;
    },
    [RESET_STATE](state) {
      Object.assign(state, getDefaultState());
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/newAddress.js